// @flow

import React from 'react';
import ReactDOM from 'react-dom';
import './sass/global_styles.css';



import App from 'app/app-container';
// import Dispatcher from './app/Dispatcher.js';
import registerServiceWorker from './registerServiceWorker';

import logger from 'logger';
logger.setLogDebug(true);

const root = document.getElementById('root');
root && ReactDOM.render(<App />, root);
registerServiceWorker();